<template>
    <div class="blog">
        <h2>エモーションダイアリーのブログ一覧</h2>
        <p><router-link to="/blog/cant-write-morningpages">モーニングページが書けない場合の対策</router-link></p>
        <p><router-link to="/blog/need-write-morningpages">モーニングページは絶対に朝に書かないといけないのか？</router-link></p>
    </div>
</template>

<script>
export default {
        mounted(){
        const title = "エモーションダイアリーのブログ｜エモーションダイアリー"
        const description = "エモーションダイアリーのブログ記事一覧のページです。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    } 

}
</script>

<style scoped>
.blog{
    max-width: 1000px;
    margin: auto;
}

</style>